import { Section } from '@/components/layout';
import { Reveal } from '@/components/motion';
import { IconFeature } from '@/components/ui';
import type { TourEvent } from '@/features/events';
import styles from './BeneficiosFunes.module.css';

/* =============================================================================
 * S3 · LOS CUATRO PILARES, los mismos que el flyer imprime al pie:
 * naturaleza y consciencia · sanación integral · comunidad y evolución ·
 * un nuevo paradigma.
 *
 * Sin iconos dibujados a medida —Funes no tiene mockup que los pida—: usa los
 * ornamentos del substrato (`IconFeature`), que es lo que ya hace el hub.
 * ========================================================================== */
export function BeneficiosFunes({ event }: { event: TourEvent }) {
  if (event.benefits.length === 0) return null;

  return (
    <Section background="surface" spacing="tight" width="default">
      <ul className={styles.grid} role="list">
        {event.benefits.map((benefit, index) => (
          <Reveal key={benefit.id} as="li" delay={index * 0.07}>
            <IconFeature benefit={benefit} layout="column" />
          </Reveal>
        ))}
      </ul>
    </Section>
  );
}
